import type { ThemeType } from "~/components/article/article-render/theme";

export const theme: ThemeType = {
  articleTypeColor: "#34b8b5",
};
